module.exports = __webpack_public_path__ + "src/assets/img/start/6b6a9c65d6399f029e330e33dc481874.png";